/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

/*
// Author: Grin Zhou
*/

import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import Select from '../Select/index.js';
import InputText from '../InputText/InputText.js';

const RegionProportional = (props) => {
  const {
    itemArray,
    onChangeAction,
    onTextChangeAction,
    onAddAction,
    onDelAction,
    addBtnText,
    removeText,
    disabled,
    repeatMax,
    handleBlurAction
  } = props;

  const overlapLabel = {labelContent: '%', float: 'right'};
  const canDel = itemArray.length>1 ? '' : 'disabled';
  const addBtnStatus = (typeof repeatMax !== 'undefined' && repeatMax <= itemArray.length) ? 'none': '';
  const deleteAction = (event) => {
    event.preventDefault();
    event.stopPropagation && event.stopPropagation();
    event.stopImmediatePropagation && event.stopImmediatePropagation();

    onDelAction && onDelAction(event.target);
    return false;
  };
  const addAction = (event) => {
    event.preventDefault();
    event.stopPropagation && event.stopPropagation();
    event.stopImmediatePropagation && event.stopImmediatePropagation();

    onAddAction && onAddAction();
    return false;
  };

  return (
    <div className="region-proportional">
        <div className="dynamic-group clearfix">
          {
            itemArray && itemArray.map((item, index) => {
              return (
                <div className="dynamic-item clearfix" key={`RP_group_${index}`}>
                    <Select
                      content={ item.selectField }
                      onChangeAction={ onChangeAction }
                      defaultValue={ item.selectField.defaultValue }
                      validationState={ item.isError ? 'error' : null }
                      hasDelBtn={ false }
                      dataIndex={ index+1 }
                      disabled={ disabled }
                    />
                  {

                    (item.inputField).map((inputObj, index2) => {
                      return (
                        <div className="reserved-item-input" key={`RP_group_${index}_select${index2}`} data-index={ index2 }>
                            <InputText
                              handleTextChange={ onTextChangeAction }
                              content={ inputObj }
                              overlapLabel={ overlapLabel }
                              parentIndex={ index }
                              dataIndex={ index2 }
                              maxLength={ 2 }
                              disabled={ disabled }
                              handleBlurAction={handleBlurAction}
                            />
                        </div>
                      )
                    })
                  }

                    <div className="group-del-btn clearfix">
                        <a
                          className={`delete-btn ${canDel}`}
                          onClick={ deleteAction }
                          data-index={ index }
                          style={{display: itemArray.length>1 ? '' : 'none'}}
                          data-key={removeText.dataKey}
                        >
                          { removeText.text }
                        </a>
                        <div className="group-dividing-line clearfix">
                            <hr aria-hidden={true} />
                        </div>
                    </div>

                </div>
              )
            })
          }
        </div>
        <div className="add-btn-row" style={{display: addBtnStatus}}>
            <Button onClick={ addAction } disabled={ false } data-key={ addBtnText.dataKey }>
                <i aria-hidden={true} className="icon icon-add">{}</i>
              { addBtnText.text }
            </Button>
        </div>
    </div>
  )
};


RegionProportional.propTypes = {
  itemArray: PropTypes.array.isRequired,
  onChangeAction: PropTypes.func,
  onTextChangeAction: PropTypes.func,
  onAddAction: PropTypes.func,
  onDelAction: PropTypes.func,
  addBtnText: PropTypes.object,
  removeText: PropTypes.object,
  disabled: PropTypes.bool,
  repeatMax: PropTypes.number,
  handleBlurAction: PropTypes.func
};

RegionProportional.defaultProps = {
  itemArray: [],
  disabled: false
};

export default RegionProportional


// WEBPACK FOOTER //
// ./src/shared/AOForm/components/RegionProportional/index.js